<template>
    <div class="container">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px">
        <el-form-item label="零部件标识码" prop="id12">
          <el-select v-model="ruleForm.id12" placeholder="请选择零部件标识码">
            <el-option
              v-for="item in lbjDict"
              :key="item.val"
              :label="item.showmsg"
              :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商" prop="id7">
          <el-input v-model="ruleForm.id7" ></el-input>
        </el-form-item>
        <el-form-item label="流水号" prop="id4">
          <el-input v-model="ruleForm.id4"></el-input>
        </el-form-item>
        <el-form-item label="标签数量" prop="sum">
          <el-input v-model="ruleForm.sum" ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>

      <download-excel
        class   = "btn btn-default"
        :data   = "json_data"
        :fields = "json_fields"
        worksheet = "明细"
        name    = "明细.xls">
        <el-button type="success"> excel导出  </el-button>
      </download-excel>
    </div>
</template>

<script>

  var jsonData =[]

  function PrefixInteger(num, length) {
    return (Array(length).join('0') + num).slice(-length);
  }

  export default {
    data() {
      return {
        ruleForm:{
          id12: '',
          id7: 'A',
          id4: '1',
          sum: '1'
        },
        rules:{
          id12: [
            { required: true, message: '请选择零部件', trigger: 'change' }
          ],
          id7: [
            { required: true, message: '请输入供应商', trigger: 'blur' },
            { min: 1, max: 1, message: '长度为1', trigger: 'blur' }
          ],
          id4: [
            {required: true, message: '请输入流水号', trigger: 'blur' }
          ],
          sum: [
            { required: true, message: '请输入数量', trigger: 'blur' },
          ]
        },
        lbjDict:this.listConfig('bsn'),
        json_fields: {
          '零部件': 'seq',
        },
        json_data: jsonData
      }
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var ruleForm= this.$refs[formName].model;
            var month = ['1','2','3','4','5','6','7','8','9','A','B','C'];
            //2001-2030
            var year = ['1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','J','K','L','M','N','P','R','S','T','V','W','X','Y'];
            var show = ruleForm.id12;
            show = show + ruleForm.id7;

            var date = new Date();
            //获取完整的年份(4位)
            var _year = date .getFullYear();

            var index  = (_year-2000-1)%30;
            show = show + year[index];

            show = show +month[date .getMonth()]; //获取当前月份(0-11,0代表1月)
            var _date = date .getDate(); //获取当前日(1-31)
            show = show +PrefixInteger(_date,2);

            var begain = ruleForm.id4;
            if(!begain){
              begain=1;
            }

            var num = parseInt(ruleForm.sum);
            begain=parseInt(begain);
            jsonData.length=0;
            var msg = "";
            for(var i=begain;i<begain+num;i++){
              jsonData[i-begain]={'seq':show+PrefixInteger(i,4)};
              msg+= show+PrefixInteger(i,4)+"\n";
           //   console.log(show+PrefixInteger(i,4));
            }

            this.$message({
              type: 'info',
              message: msg
            });

            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/views/HelloWorld.vue